import { render, staticRenderFns } from "./ImportPremiumPodcast.vue?vue&type=template&id=516cc36a"
import script from "./ImportPremiumPodcast.vue?vue&type=script&lang=js"
export * from "./ImportPremiumPodcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports